import { createSelector } from 'reselect';
import { appealSubmitSubjectObjectSelector } from '../examData/selectors';
import { appealSubmitIdentityDocumentSelector } from '../passport/selectors';
import { appealSubmitIdentityDocumentSelector as appealSubmitIdentityDocumentChildSelector } from '../passportChild/selectors';
import { appealSubmitPersonSelector } from '../mainData/selectors';
import { appealSubmitPersonSelector as appealSubmitPersonChildSelector } from '../mainDataChild/selectors';
import { appealSubmitParticipantSelector } from '../gia/selectors';
import { appealSubmitActRecordSelector } from '../actRecord/selectors';

export const appealDataRequestSelector = state => state.appealDataRequest;

export const appealDataRequestLoadingSelector = createSelector(
  appealDataRequestSelector,
  subState => subState.loading
);

export const appealDataRequestStructureSelector = createSelector(
  appealSubmitSubjectObjectSelector,
  appealSubmitIdentityDocumentSelector,
  appealSubmitParticipantSelector,
  appealSubmitPersonSelector,
  appealSubmitActRecordSelector,
  /* eslint-disable camelcase */
  (subject, document, participant, declarant, gia_participant) => {
    const private_persons = [
      {
        type: 'DECLARANT',
        ...declarant,
        documents: [document]
      }
    ];

    return {
      contacts: {
        private_persons
      },
      properties: {
        subject,
        participant,
        gia_participant,
        applicant_consent: true
      }
    };
  }
  /* eslint-enable camelcase */
);

export const appealDataRequestParentStructureSelector = createSelector(
  appealSubmitSubjectObjectSelector,
  appealSubmitIdentityDocumentSelector,
  appealSubmitParticipantSelector,
  appealSubmitPersonSelector,
  appealSubmitIdentityDocumentChildSelector,
  appealSubmitPersonChildSelector,
  appealSubmitActRecordSelector,
  /* eslint-disable camelcase */
  (
    subject,
    document,
    participant,
    declarant,
    child_document,
    child,
    gia_participant
  ) => {
    const private_persons = [
      {
        type: child ? 'LEGAL_REPRESENTATIVE' : 'DECLARANT',
        ...declarant,
        documents: [document]
      }
    ];

    if (child) {
      private_persons.push({
        type: 'DECLARANT',
        ...child,
        documents: [child_document]
      });
    }

    return {
      contacts: {
        private_persons
      },
      properties: {
        subject,
        participant,
        gia_participant,
        applicant_consent: true
      }
    };
  }
  /* eslint-enable camelcase */
);
